import InfiniteSelect from './InfiniteSelect.vue'

export default InfiniteSelect
